module.exports = __webpack_public_path__ + "static/Texture1-aa6c0cd4d9baae11acd5b3bdd04d8e4f.svg";